export enum PAGE_TYPE {
    ALL = 'all',
    PRODUCTS = 'products',
    RECIPES = 'recipes',
    ARTICLES = 'articles'
}